export const INVENTORY_SEARCH_PLACEHOLDER_MESSAGE = 'Search by Item or Name'
export const INVENTORY_SEARCH_PLACEHOLDER_MESSAGE_SHORT = 'Item or Name'
